import React from 'react'
import { MenuItem, Button, Divider } from '@mui/material'
import AccountCircleMenu from '../../../Assets/Images/svgs/account-circle-menu'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import ListAltIcon from '@mui/icons-material/ListAlt'
import styles from './ProfileMenu.module.scss'

interface ProfileMenuProps {
  userName: string
  userEmail: string
  onLogout: () => void
  onClose: () => void
  onListingPref: () => void
  onNotificationPref: () => void
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({
  userName,
  userEmail,
  onLogout,
  onClose,
  onListingPref,
  onNotificationPref,
}) => (
  <div className={styles.profileMenuContainer}>
    <div className={styles.profileHeader}>
      <AccountCircleMenu />
      <div className={styles.userInfo}>
        <div className={styles.userName}>{userName}</div>
        <div className={styles.userEmail}>{userEmail}</div>
      </div>
    </div>
    <Divider className={styles.divider} />
    <div className={styles.listData}>
      <MenuItem
        component='a'
        href='/listing-screen-preference'
        className={styles.menuItem}
        onClick={(e) => {
          if (!(e.ctrlKey || e.metaKey || e.button === 1)) {
            e.preventDefault()
            onListingPref()
          }
        }}
      >
        <ListAltIcon className={styles.menuIcon} />
        Listing Screen Preference
      </MenuItem>
      <MenuItem
        component='a'
        href='/notifications-preference'
        className={styles.menuItem}
        onClick={(e) => {
          if (!(e.ctrlKey || e.metaKey || e.button === 1)) {
            e.preventDefault()
            onNotificationPref()
          }
        }}
      >
        <NotificationsNoneIcon className={styles.menuIcon} />
        Notifications Preference
      </MenuItem>
    </div>

    <div className={styles.buttonRow}>
      <Button variant='contained' color='error' className={styles.logoutBtn} onClick={onLogout}>
        Logout
      </Button>
      <Button variant='outlined' className={styles.closeBtn} onClick={onClose}>
        Close
      </Button>
    </div>
  </div>
)

export default ProfileMenu
